// Imports
import React from 'react'
import PropTypes from 'prop-types'
import { getImageSource } from '../../product/api/routes'

// Component
const Image = ({ src, defaultSrc, size, alt, style }) => {
  const fallback = defaultSrc || getImageSource();

  return (
    <img
      src={src || fallback}
      style={style ? style : (size === '100%' ? { width: size } : { width: size, height: 'auto' })}
      onError={e => {
        if (e.target.dataset.fallbackTried) {
          e.target.onerror = null;
          return;
        }
        e.target.dataset.fallbackTried = "true";
        e.target.onerror = null;
        if (fallback) {
          e.target.src = fallback;
        }
      }}
      alt={alt}
    />
  );
}

// Component Properties
Image.propTypes = {
  src: PropTypes.string,
  defaultSrc: PropTypes.string,
  size: PropTypes.any,
  alt: PropTypes.string,
  style: PropTypes.object
}
Image.defaultProps = {
  size: 40,
  alt: ''
}

export default Image

